import * as React from 'react'
import styled from 'styled-components'
// import { device } from '../../templates/displays/devices'
import profile_blank from '@/public/assets/placeholders/profile_pic_placeholder.svg'
import { device } from '@/components/templates/displays/devices'

const Wrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
`

const UserDetails = styled.div`
    width: 100%;
    padding-left: 20px;
`

const UserName = styled.div`
    font-family: Lato-light;
    font-size: 16px;
    text-transform: uppercase;
    padding-bottom: 10px;
    @media ${device.mobile_and_ipad} {
        font-size: 15px;
    }
`

const UserLocation = styled.div`
    font-family: Lato-light;
    font-size: 15px;
    font-style: italic;
    color: #656565;
    @media ${device.mobile_and_ipad} {
        font-size: 14px;
    }
`

type IPicProps = {
    profile_image_url: string | undefined
}

const ProfilePic = styled.div<IPicProps>`
    width: 60px;
    height: 60px;

    @media ${device.mobile_and_ipad} {
        width: 60px;
        height: 60px;
    }
    border: 1px solid #00a9af;
    border-radius: 50%;
    background-image: ${(props) =>
        props.profile_image_url
            ? `url(${props.profile_image_url})`
            : `url(${profile_blank.src})`};
    background-position: center;
    background-size: cover;
`

const ProfilePicWrapper = styled.div`
    width: 60px;
    height: 60px;

    @media ${device.mobile_and_ipad} {
        width: 60px;
        height: 60px;
    }
`

type IProps = {
    profile_image_url?: string | undefined
    userName: string
    userLocation: string
}

const UserBox: React.FunctionComponent<IProps> = (props) => {
    return (
        <Wrapper>
            <ProfilePicWrapper>
                <ProfilePic profile_image_url={props.profile_image_url} />
            </ProfilePicWrapper>
            <UserDetails>
                <UserName>{props.userName}</UserName>
                <UserLocation>{props.userLocation}</UserLocation>
            </UserDetails>
        </Wrapper>
    )
}

export default UserBox
